module.exports = __webpack_public_path__ + "img/Otelico-logo-text-bleu.415e8751.png";